import { ShoppingCart } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useCart } from "../hooks/useCart";

export const CartHeaderWidget = (): JSX.Element => {
    const {
        count,
        timerDisplay,
        timerStatus,
        cartItems,
        reservationTime,
        isCartOpen,
        cartLabels,
        toggleCartOpen,
        removeProductById,
        removingItemId,
        handleCheckoutFromModal,
    } = useCart();

    const showTimer = count > 0 && Boolean(timerDisplay);

    return (
        <ShoppingCart
            count={count}
            timer={showTimer ? timerDisplay : undefined}
            timerStatus={timerStatus}
            isActive={isCartOpen}
            showTooltip={true}
            tooltipTitle={cartLabels.tooltipTitle}
            items={cartItems}
            reservationTime={reservationTime}
            emptyTitle={cartLabels.emptyTitle}
            emptyDescription={cartLabels.emptyDescription}
            timerPrefix={cartLabels.timerPrefix}
            checkoutLabel={cartLabels.goToCartLabel}
            onToggle={toggleCartOpen}
            onCheckout={handleCheckoutFromModal}
            onRemoveItem={(id: string) => void removeProductById(Number(id))}
            removingItemId={removingItemId}
        />
    );
};
